export default __webpack_public_path__ + "static/media/arrow.312d23db.png";